import styled, { css } from 'styled-components'

export const Wrapper = styled.nav`
  ${() => css`
    width: 300px;
    padding-top: 40px;
    margin-left: 24px;
  `}
`
